const PENDING_JOIN_CODE_KEY = 'pendingJoinClassCode';

/** Stashes a value across the login round-trip; consumed in app/page.tsx once a real user is signed in. */
export function stashPendingJoinCode(code: string): void {
  try {
    localStorage.setItem(PENDING_JOIN_CODE_KEY, code);
  } catch (e) {}
}

export function peekPendingJoinCode(): string | null {
  try {
    return localStorage.getItem(PENDING_JOIN_CODE_KEY);
  } catch (e) {
    return null;
  }
}

export function consumePendingJoinCode(): string | null {
  try {
    const code = localStorage.getItem(PENDING_JOIN_CODE_KEY);
    if (code) localStorage.removeItem(PENDING_JOIN_CODE_KEY);
    return code;
  } catch (e) {
    return null;
  }
}
